module.exports = __webpack_public_path__ + "img/element.400fdd7d.svg";